module.exports = __webpack_public_path__ + "img/Trillionaire-1.47951ea0.png";